<template>
  <div id="app">
    <template>
      <a-layout id="components-layout-demo-responsive">
        <a-layout-sider
          breakpoint="lg"
          collapsedWidth="0"
          theme="dark"
          align="left"
          v-if="isLogin !== null && showUI"
          >
          <div class="logo" >
            <img :src="company.logo" style="height: 100%;max-width: 100%;  object-fit: contain;" />
          </div>
          <a-menu theme="dark" mode="inline">
            <a-menu-item key="panel">
              <router-link to='/'>
                <a-icon type="calendar" />
                <span class="nav-text">Panel</span>
              </router-link>
            </a-menu-item>

            <a-menu-item key="listas">
              <router-link to='/listas'>
                <a-icon type="contacts" />
                <span class="nav-text">Listas</span>
              </router-link>
            </a-menu-item>

            <a-menu-item key="Mensajes">
              <router-link to='/messages'>
                <a-icon type="message" />
                <span class="nav-text">Mensajes</span>
              </router-link>
            </a-menu-item>

            <a-menu-item key="blacklist">
              <router-link to='/blacklist'>
                <a-icon type="usergroup-delete" />
                <span class="nav-text">Lista Negra</span>
              </router-link>
            </a-menu-item>
            <a-menu-item key="Usuario" v-if="rol === '1'">
              <router-link to='/Usuario'>
                <a-icon type="user" />
                <span class="nav-text">Usuarios</span>
              </router-link>
            </a-menu-item>
            <a-menu-item key="configurations" v-if="rol === '1'">
              <router-link to='/configurations'>
                <a-icon type="setting" />
                <span class="nav-text">Configuración</span>
              </router-link>
            </a-menu-item>
            <a-menu-item key="logs" v-if="rol === '1'">
              <router-link to='/logs'>
                <a-icon type="hourglass" />
                <span class="nav-text">Logs</span>
              </router-link>
            </a-menu-item>
            <a-menu-item key="cerrarsesion" v-if="isLogin !== null" @click="cerrarSesion()">
              <a-icon type="unlock" />
              <span class="nav-text">Cerrar Sesión</span>
            </a-menu-item>
          </a-menu>
        </a-layout-sider>
        
        <a-layout>
          <a-layout-header style="background-color: #ffffff; padding: 0 20px; display: flex; justify-content: space-between; align-items: center;"  v-if="isLogin !== null && showUI">
            <a-row type="flex" align="middle" justify="space-between" :gutter="20" style="width: 100%; text-align: left;">
              <a-col>
                <a-breadcrumb>
                  <a-breadcrumb-item>
                    <router-link to='/'>
                        <a-icon type="home"/>
                      <span class="nav-text">   </span>
                    </router-link> 
                  </a-breadcrumb-item>
                  <a-breadcrumb-item href="">
                    <span> {{$root.$route["name"]}}</span>
                  </a-breadcrumb-item>
                </a-breadcrumb>
              </a-col>
              <a-col style="display: flex;align-items: center;justify-content: space-between;">
                <!-- boton de crear mail -->
                <a-button type="primary" size="large" v-if="isLogin !== null">
                  <router-link to='/email/nuevo'>
                    <a-icon type="profile" style="margin-right: 10px;" />
                    <span class="nav-text">Crear Nuevo Email</span>
                  </router-link>
                </a-button>
              </a-col>
            </a-row>
          </a-layout-header>

          <a-layout-content class="layout-content">
            <router-view/>
            <!-- Dashboard -->
            <!-- <panel v-if="seccion[0] == 'panel' "/> -->
            <!-- Formulario -->
            <!-- <formulario v-if="seccion[0] == 'formulario' " /> -->
            <!-- Gestor de Listas -->
            <!-- <gestorListas v-if="seccion[0] == 'listas' "/> -->

          </a-layout-content>

          <a-layout-footer style="textAlign: center">
          </a-layout-footer>

        </a-layout>
      </a-layout>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'


Vue.use(Antd)


export default {
  name: 'app',
  components: {
  },
  data() {
    return {
      isLogin: JSON.parse(localStorage.getItem("md5")),
      rol: JSON.parse(localStorage.getItem("rol")),
      company: JSON.parse(localStorage.getItem('company'))
    }
  },mounted:function(){
  },
  methods: {
    cerrarSesion() {      
      localStorage.removeItem("md5");
      localStorage.removeItem("rol");
      this.$router.go();
    },
  },
  computed: {
    showUI: function() {
      return this.$route.name !== 'unsuscribe';
    }
  }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #components-layout-demo-responsive{
    min-height: 100vh;
  }
  #components-layout-demo-responsive .logo {
    height: 32px;
    margin: 16px 26px;
  }
  .layout-content{
    width: calc(100% - 60px);
    max-width: 1300px;
    margin: 40px auto;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-header {
    display: none !important;
  }


  .modelTagCalendar .ant-modal-content .ant-modal-header, .modelTagCalendar .ant-modal-content .ant-modal-footer{
    display: none;
  }
  .modelTagCalendar .ant-modal-content .ant-modal-body{
    padding: 0px;
  }
  .has-warning .ant-form-explain, .has-warning .ant-form-split,.has-error .ant-form-explain, .has-error .ant-form-split{
    font-size: 12px;
    text-align: left;
  }
  .ant-form label {
    font-size: 15px;
    font-weight: 600;
  }
  .ant-form-item-label label{
    color: #333333;
  }
  .ant-form .ant-form-item-control label {
    font-size: 13px;
    color: #a6a6a6;
  }
  .ant-form-vertical  .ant-form-item-control  .ant-form-item-label {
      margin-bottom: -3px;
      margin-top: 3px;
  }
  .ant-input-lg, .ant-select-lg, .ant-time-picker-large .ant-time-picker-input{
    font-size: 14px;
  }
  .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header{
    color: rgba(0, 0, 0, 0.85);
    cursor: auto;
  }
</style>
